import { SxProps, Theme } from '@mui/material';

import { PAGE_GUTTER } from './layout';


const CELL_INLINE_PADDING = 'var(--space-6)';

interface ListSurfaceOptions {
  isMobile: boolean;
  clearFloatingCreateButton?: boolean;
}

export const listSurfaceSx = ({
  isMobile,
  clearFloatingCreateButton = false,
}: ListSurfaceOptions): SxProps<Theme> =>
  isMobile
    ? {
        '& .RaList-main': {
          px: PAGE_GUTTER,
          ...(clearFloatingCreateButton ? { pb: 'var(--space-20)' } : {}),
        },
        '& .RaList-content': {
          border: 'none !important',
          borderRadius: '0 !important',
          boxShadow: 'none',
          background: 'transparent',
        },
      }
    : {
        '& .RaList-main': {
          px: PAGE_GUTTER,
          pb: 'var(--space-8)',
        },
        '& .RaList-content': {
          border: '1px solid var(--color-border)',
          borderRadius: 'var(--radius-lg)',
        },
        '& .RaDatagrid-tbody tr:last-of-type td': {
          borderBottom: 'none',
        },
        '& th.MuiTableCell-root': {
          paddingLeft: CELL_INLINE_PADDING,
          py: 'var(--space-4)',
          fontSize: 'var(--text-xs)',
        },
        '& td.MuiTableCell-root': {
          paddingLeft: CELL_INLINE_PADDING,
          py: 'var(--space-2)',
        },
      };
